import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

export const getSchema = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/review/grantee`
  return doGet(url)
}

export const getGranteeProfileInfoForDirectorSchema = (projectVersionId) => {
  const url = `${API_ROOT}/approval/${projectVersionId}/review/grantee`
  return doGet(url)
}

export const save = (request) => {
  const url = `${API_ROOT}`
  return doPost(url, request)
}
